module.exports = __webpack_public_path__ + "img/白花蛇舌草.ad78be07.jpg";